export { fetchBinaryContent } from "./binary-service";